import angular from 'angular'
import moment from 'moment-timezone'
import * as _ from 'lodash'
import Ajv from 'ajv'
import intl from 'react-intl-universal'

import exceptionTypes from '../errors/exception.types.js'
import CONSTANTS from '~/constants'

/* One of the pitfalls of a centralized datastore hits you in the face when
 * I want to breakout components into thier own parts. The core draw back is
 * you are forced to pick a few dirty options.
 *
 * 1. Load the same endpoint, multiple times. Today, a PWA could handle this load, but we don't have that here with
 *  Ellipsis.
 * 2. Seperate out all the endpoints and call two or three individually.
 * 3. Manage the request/callstack.
 */

export default [
  '$q',
  'settingsService',
  '$rootScope',
  '$timeout',
  '$http',
  'errorDelegationService',
  'toastr',
  'storyService',
  locklessService,
]
const objectEquals = function objectEquals(alpha, bravo, deepCheck = false) {
  /*
   * I'd rather write a hashing function....but thats not ideal...yet.
   */
  let alphaProps = Object.getOwnPropertyNames(alpha)
  let bravoProps = Object.getOwnPropertyNames(bravo)
  if (alphaProps.length !== bravoProps.length) {
    return false
  }
  for (let idx = 0; idx < alphaProps.length; idx++) {
    let key = alphaProps[idx]
    if (!Object.prototype.hasOwnProperty.call(bravo, key)) {
      return false
    }
    if (alpha[key] !== bravo[key]) {
      return false
    }
    if ({}.constructor === bravo[key].constructor) {
      if (deepCheck) {
        console.error('Unsupported feature')
      }
    }
  }
  return true
}
const resultRequestStack = []
const requestResult = function(workerFunc, defer, params = {}) {
  resultRequestStack.push({
    workerFunc: workerFunc,
    defer: defer,
    params: params,
  })
  // resultRequestStack.length - 1 because we don't want to operate on the latest addition to the resultRequestStack.
  for (let idx = 0; idx < resultRequestStack.length - 1; idx++) {
    let rr = resultRequestStack[idx]
    if (rr['workerFunc'] === workerFunc) {
      if (!objectEquals(rr['params'], params)) {
        return false
      }
    }
  }
  return true
}
const strikeResultStack = function(
  workerFunc,
  payload,
  params = {},
  isSuccess = true
) {
  // Go backwards for two reasons.
  //  If the object is modified while we're working on it, it'll be added to the end of the array and not the front.
  //  When we need to trim something out of the data-structure, the data-structure will only be altered at the
  //    current index and above.
  let deferred = []
  for (let idx = resultRequestStack.length - 1; idx >= 0; idx--) {
    let rr = resultRequestStack[idx]
    if (rr['workerFunc'] === workerFunc) {
      if (objectEquals(rr['params'], params)) {
        deferred.push(rr)
        resultRequestStack.splice(idx, 1)
      }
    }
  }
  for (let idx = 0; idx < deferred.length; idx++) {
    let rr = deferred[idx]
    if (isSuccess) {
      rr['defer'].resolve(JSON.parse(JSON.stringify(payload)))
    } else {
      rr['defer'].reject(payload)
    }
  }
}
function locklessService(
  $q,
  settingsService,
  $rootScope,
  $timeout,
  $http,
  errorDelegationService,
  toastr,
  storyService
) {
  /*
   * I don't like using self, however this was imposed upon me by a scoping issue with angulars $timeout.
   */
  const self = this
  console.log('lockless.count-me')
  /*
   * Replaces,
   *  https://github.com/WPMedia/arc-story-builder-ui/blob/62c042d427fe3d74715f9fc537476f1d33ed641e/html/modules/services/publish.js#L130
   */
  const publicationArityValidator = new Ajv().compile({
    title: 'Schedule Publication Arity',
    type: 'object',
    properties: {
      editions: {
        type: 'array',
        items: { type: 'string' },
      },
      _id: { type: 'string' },
      revision_id: { type: 'string' },
      scheduleDateTime: { type: 'object' }, // moment
      display_date: { type: 'object' }, // moment
    },
    required: [
      'editions',
      '_id',
      'revision_id',
      'display_date',
      'scheduleDateTime',
    ],
  })
  this.commitPublication = function commitPublication(details) {
    if (!publicationArityValidator(details)) {
      throw new exceptionTypes.InvalidAttribute({
        errors: publicationArityValidator.errors,
        message: 'InvalidAttribute',
      })
    }
    details['display_date'] = details['display_date'].toISOString()
    let isPublish = true
    let requestParams = null
    if (details['scheduleDateTime'] > moment().add(1, 'minutes')) {
      toastr.info(intl.get('lockless.commitPublication.scheduling'))
      details['scheduleDateTime'] = details['scheduleDateTime'].toISOString()

      isPublish = false
      requestParams = {
        method: 'PUT',
        url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/schedule/${
          details._id
        }/edition/${details.editions[0]}`,
        data: details,
      }
    } else {
      delete details['scheduleDateTime']
      toastr.info(intl.get('lockless.commitPublication.publishing'))

      requestParams = {
        method: 'PUT',
        url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/publish/${
          details._id
        }/edition/${details.editions[0]}`,
        data: details,
      }
    }
    // Remove redundent data that was used in the contruction of the URIs
    delete requestParams['data']['_id']
    delete requestParams['data']['editions']

    const defer = $q.defer()

    $http(requestParams, {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(
        function commitPublicationSuccess(response) {
          this.storyObj = response.data
          if (isPublish) {
            // Published
            $rootScope.$broadcast('NEW_REVISION', {
              display_date: response.data.display_date,
              revision: { revision_id: response.data.revision_id },
            })
            $rootScope.$broadcast('STORY_PUBLISHED', {
              storyObj: response.data,
            })
            defer.resolve(['published', this.storyObj])
          } else {
            // Scheduled
            // this.storyObj.revision.revision_id = response.data.revision_id
            $rootScope.$broadcast('NEW_REVISION', {
              display_date: response.data.display_date,
              revision: { revision_id: response.data.revision_id },
            })
            $rootScope.$broadcast('STORY_SCHEDULED', {
              storyObj: response.data,
            })
            defer.resolve(['scheduled', this.storyObj])
          }
        }.bind(this)
      )
      .catch(function commitPublicationError(response) {
        defer.reject(response)
      })
    return defer.promise
  }.bind(this)
  /*
   * With the intent to create a uniform API, I've ironed the dirty of what needed to happen to load the userRolesAuth
   *  object that exists within the auth.js.
   *
   * userRolesAuth
   *  returns deferred: window.userRolesAuth
   */
  this.userRolesAuth = null
  this.loadUserRolesAuth = function loadUserRolesAuth() {
    const defer = $q.defer()
    const requestParams = {}
    const isFresh = requestResult(this.loadUserRolesAuth, defer, requestParams)
    if (!isFresh) {
      return defer.promise
    }
    // userRolesAuth will only be loaded once within the life cycle of Ellipsis.
    if (angular.isDefined(this.userRolesAuth) && this.userRolesAuth !== null) {
      $timeout(
        function skipABeat() {
          strikeResultStack(
            this.loadUserRolesAuth,
            this.userRolesAuth,
            requestParams
          )
        }.bind(this),
        0
      )
      return defer.promise
    }

    const USER_ROLES_KEY = 'userRolesAuth'
    const self = this
    const userRolesAuthMaxRetry = 1000
    const userRolesAuthDelay = 100
    let userRolesAuthCurrentRetry = 0
    const detectUserRolesAuth = function detectUserRolesAuth() {
      // Defend from an infinate loop, fail fast.
      if (userRolesAuthMaxRetry < userRolesAuthCurrentRetry) {
        strikeResultStack(
          self.loadUserRolesAuth,
          { message: 'Unable to load User Roles' },
          requestParams,
          false
        )
      }
      userRolesAuthCurrentRetry = userRolesAuthCurrentRetry + 1
      if (!Object.prototype.hasOwnProperty.call(window, USER_ROLES_KEY)) {
        $timeout(detectUserRolesAuth, userRolesAuthDelay)
      } else {
        self.userRolesAuth = window[USER_ROLES_KEY]
        strikeResultStack(
          self.loadUserRolesAuth,
          self.userRolesAuth,
          requestParams
        )
      }
    }
    $timeout(detectUserRolesAuth, userRolesAuthDelay)
    return defer.promise
  }.bind(this)

  // Get Scheduled Publications
  this.loadScheduledPublications = function loadScheduledPublications(storyId) {
    const defer = $q.defer()
    const requestParams = {
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/schedule/${storyId}`,
      method: 'GET',
    }
    const isFresh = requestResult(
      self.loadScheduledPublications,
      defer,
      requestParams
    )
    if (!isFresh) {
      return defer.promise
    }
    this.loadUserRolesAuth()
      .then(function(userRolesAuth) {
        if (angular.isUndefined(userRolesAuth.org)) {
          strikeResultStack(
            this.loadScheduledPublications,
            {
              message: 'Configuration Error: Contact Arc Professional Services',
            },
            requestParams,
            false
          )
        } else if (
          angular.isUndefined(userRolesAuth.org.schedule_publish) ||
          userRolesAuth.org.schedule_publish === null
        ) {
          strikeResultStack(
            this.loadScheduledPublications,
            { message: 'Unable to schedule a publication' },
            requestParams,
            false
          )
        } else {
          $http(requestParams, {
            headers: {
              Accept: 'application/json',
            },
          })
            .then(function scheduleSuccess(response) {
              strikeResultStack(
                self.loadScheduledPublications,
                response.data.schedule,
                requestParams
              )
            })
            .catch(function scheduleError(error) {
              strikeResultStack(
                self.loadScheduledPublications,
                error,
                requestParams,
                false
              )
            })
        }
      })
      .catch(function(error) {
        strikeResultStack(
          self.loadScheduledPublications,
          error,
          requestParams,
          true
        )
      })
    return defer.promise
  }.bind(this)
  // Story Obj
  /*
   * I'd rather load this from a network request, but I'll load it from the ELLIPSIS_STORY_LOADED event instead.
   *
   * If the local object is defined, return in. If no local object is found, bind to the ELLIPSIS_STORY_LOADED event
   *  and upon hearing said event. Kill it. To defend against stale story objects, listen for SAVE_STORY and repeat
   *  the cycle.
   */
  this.storyObj = null

  $rootScope.$watch(
    'story',
    function(newValue, oldValue) {
      if (angular.isDefined(newValue)) {
        this.storyObj = newValue
        strikeResultStack(this.loadStoryObject, newValue)
      }
    }.bind(this)
  )

  $rootScope.$on('SAVE_SUCCESS', ($event, storyObj) => {
    this.storyObj = storyObj['story']
  })

  this.loadStoryObject = function loadStoryObject() {
    const defer = $q.defer()
    if (angular.isDefined(this.storyObj)) {
      $timeout(
        function skipABeat() {
          defer.resolve(this.storyObj)
        }.bind(this),
        0
      )
    } else {
      requestResult(this.loadStoryObject, defer)
    }
    return defer.promise
  }.bind(this)

  this.loadPublishState = function loadPublishState() {
    const defer = $q.defer()
    this.loadStoryObject()
      .then(function loadStoryObjectSuccess(storyObj) {
        defer.resolve({
          isPublished:
            _.get(storyObj, 'additional_properties.is_published') || false,
          publishedDate:
            _.get(storyObj, 'additional_properties.publish_date') || undefined,
        })
      })
      .catch(errorDelegationService.handle)
    return defer.promise
  }
  // Settings Obj
  this.loadSettings = function loadSettings() {
    return this.fetchOrgSettings()
  }.bind(this)
  // Depricate...eventually.
  this.fetchOrgSettings = function locklessServiceFetchOrgSettings() {
    const defer = $q.defer()
    const requestParams = {}
    let isFresh = requestResult(this.fetchOrgSettings, defer, requestParams)
    if (isFresh) {
      settingsService
        .fetchSettings('org')
        .then(
          function fetchOrgSettingsSuccess(settings) {
            strikeResultStack(
              this.fetchOrgSettings,
              settings['data'],
              requestParams
            )
          }.bind(this)
        )
        .catch(
          function fetchOrgSettingsError(err) {
            strikeResultStack(
              this.fetchOrgSettings,
              err,
              {},
              false,
              requestParams
            )
          }.bind(this)
        )
    }
    return defer.promise
  }.bind(this)
}
